import { Module } from '../Module';
import { IStackedElement, StackedElementsService } from './StackedElementsService';

export interface IBackdropInstance {
  remove: () => void;
}

export class BackdropService {

  public static $inject = [ 'StackedElementsService' ];

  private StackedElementsService: StackedElementsService;

  constructor(StackedElementsService: StackedElementsService) {
    this.StackedElementsService = StackedElementsService;
  }

  public add(): IBackdropInstance {
    const fillWindow = () => { return { left: 0, top: 0, right: 0, bottom: 0 }; };
    const backdropElement = angular.element('<div>').addClass('tb-backdrop');

    const backdropStackedElement: IStackedElement = this.StackedElementsService.addStackedElement({
      contentElement: backdropElement,
      getContentElementPosition: fillWindow
    });

    const backdropInstance: IBackdropInstance = {
      remove: () => { this.StackedElementsService.removeStackedElement(backdropStackedElement); }
    };

    return backdropInstance;
  }

}

Module.instance().service('BackdropService', BackdropService);
